import isEmpty from 'lodash/isEmpty';

type SearchParamsObjectAttributes = {
  [key: string]: string | boolean;
};

/**
 * @remarks This function is used to get the object attributes from the search
 * params, given an object key.
 *
 * @param urlParams - The URL search params.
 * @param objectKey - The key of the object to get the attributes from.
 * @returns An object of type {@link SearchParamsObjectAttributes} or null if
 * the object key is not found.
 *
 * @example
 * const urlParams = new URLSearchParams('obj[key1]=value1&obj[key2]=value2');
 * const objectAttributes = queryStringToAttributes(urlParams, 'obj');
 * console.log(objectAttributes); // \{ key1: 'value1', key2: 'value2' \}
 */
export function queryStringToAttributes(
  urlParams: URLSearchParams,
  objectKey: string
): SearchParamsObjectAttributes | null {
  const paramsObject: SearchParamsObjectAttributes = {};
  for (const [key, value] of urlParams.entries()) {
    if (key.includes(objectKey) && value) {
      // If the key contains brackets, handle it as a nested object
      const objectKeyRegex = new RegExp(objectKey + '\\[|\\]', 'gi');
      const keys = key.split(objectKeyRegex).filter(Boolean); // Split by brackets and filter out empty strings
      keys.forEach(k => {
        paramsObject[k] = value; // Set the value at the last key
      });
    }
  }

  return isEmpty(paramsObject) ? null : paramsObject;
}
